import {Component, OnDestroy, OnInit, signal, Signal, ViewChild, ViewContainerRef} from '@angular/core';
import {CreateTramiteComponent} from "../../../../../tramitantes/src/app/pages/tramitante/create-tramite/create-tramite.component";
import {ActivatedRoute} from "@angular/router";
import {ICustomComponent} from "../../../../../tramitantes/src/app/shared/interfaces/configuracion";
import {
  AgregarMiembroComponent,
  ModificarDocumentoComponent,
  RetiroMiembroComponent
} from "../../pages/sisben";

@Component({
  selector: 'app-custom-create-tramites',
  standalone: true,
  imports: [],
  template: `
    <ng-container #content></ng-container>`,

})
export class CustomCreateTramitesComponent implements OnInit, OnDestroy {

  private name: string | undefined;
  private isCustom:boolean = false;
  private props :Signal<any> | undefined = undefined;
  constructor(private _route: ActivatedRoute) {
  }

  @ViewChild('content', {static: true, read: ViewContainerRef})
  container!: ViewContainerRef;

  ngOnInit(): void {
    const props:ICustomComponent = this._route.snapshot.data['customComponent'];
    if (props) {
      this.name = props.nombre;
      this.props = signal(props);
    }
     this.loadComponent();
  }

  ngOnDestroy(): void {
    this.container.remove();
    this.cleanProps();
  }

  private loadComponent(): void {
    this.container.clear();
    const component: any = this.getComponent()
    const containerRef = this.container.createComponent(component);
    if (this.isCustom) {
      // @ts-ignore
      containerRef.instance.props = this.props;
    }
  }

  getComponent() {
    if (!this.name) return CreateTramiteComponent;
    this.isCustom = true;
    if (this.name === 'AgregarMiembroComponent')
      return AgregarMiembroComponent;
    if (this.name === 'ModificarDocumentoComponent')
      return ModificarDocumentoComponent;
    if (this.name === 'RetiroMiembroComponent')
      return RetiroMiembroComponent;
    this.isCustom = false;
    return CreateTramiteComponent;
  }

  cleanProps(): void {
      this.name = undefined;
      this.isCustom = false;
      this.props = undefined;
  }
}
